import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

interface ChartData {
  label: string;
  data: number[];
  backgroundColor?: string[];
  borderColor?: string[];
  borderWidth?: number;
}

interface BarChartProps {
  title: string;
  xLabels: string[];
  dataSets: ChartData[];
  horizontal?: boolean;
  height?: number | string;
}

const BarChart: React.FC<BarChartProps> = ({
  title,
  xLabels,
  dataSets,
  horizontal = false,
  height = 400,
}) => {
  const chartData = {
    labels: xLabels,
    datasets: dataSets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: horizontal ? ('y' as const) : ('x' as const),
    scales: horizontal
      ? {
          x: { beginAtZero: true },
          y: { ticks: { autoSkip: false } },
        }
      : {
          y: { beginAtZero: true },
          x: {
            ticks: {
              maxRotation: 45,
              minRotation: 45,
            },
          },
        },
  };

  return (
    <div style={{ width: '100%', height: typeof height === 'number' ? `${height}px` : height }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BarChart;
